import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPatchRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IModelResponseSchema,
  IModelSubmitSchema,
} from "./modelAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllModelAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IModelResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.MODEL, searchParams, signal });

const getSingleModelAPI = (
  id: string
): Promise<{ data: IModelResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.MODEL }/${id}`,
  });

const createModelAPI = (
  data: IModelSubmitSchema
): Promise<{ data: IModelResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.MODEL, data });

const updateModelAPI = (
  data: IModelSubmitSchema
): Promise<{ data: IModelResponseSchema }> =>
  handleGlobalPatchRequest({ url: `${URLS.MODEL }/${data.id}`, data });

const deleteModelAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.MODEL }/${id}` });

export {
  getAllModelAPI,
  getSingleModelAPI,
  createModelAPI,
  updateModelAPI,
  deleteModelAPI,
};